import {
    SET_CBP_RESPONSE_MESSAGE,
    GET_CBP_RESPONSE_MESSAGE_WATCHER,
    SET_CBP_RESPONSE_MESSAGE_ERROR,
  } from "../actionTypes/index";
  export const getCbpResponseMessageWatcher = (payload, resolve, reject) => {
    return { type: GET_CBP_RESPONSE_MESSAGE_WATCHER, payload, resolve, reject };
  };
  
  export const setCbpResponseMessage = (payload, resolve, reject) => {
    return { type: SET_CBP_RESPONSE_MESSAGE, payload, resolve, reject };
  };
  
  export const setCbpResponseMessageError = (payload, resolve, reject) => {
    return { type: SET_CBP_RESPONSE_MESSAGE_ERROR, payload, resolve, reject };
  };
